const imageMap = {
  "invoice": require("../assets/images/shelly.png"),
  "moad-so": require("../assets/images/debby.png"),
  "moad-w2": require("../assets/images/cindy.png"),
  "moad-pay-stub": require("../assets/images/raisa.png"),
};

export const getImages = (name, image = null) => {
  return image || imageMap[name] || require("../assets/images/alby.png"); // Default fallback image
};
